import { useQuery } from 'react-query'
import React from "react";
import { fetchSignUpsExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

function ByDeviceWithRegion({ date }) {
    const fetchData = async () => {
        const { data } = await fetchSignUpsExplorer('byDeviceWithRegion', date)
        return data.result
    }
    const { data, error, isError, isLoading } = useQuery(['signUpsByDeviceWithRegion', date], fetchData, {
        refetchOnWindowFocus: false,
    })
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer key={'byDeviceWithRegion' + date}  {...dataProps } />
}
export default ByDeviceWithRegion